import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
	root: {
		background: '#EB505E',
		borderRadius: '48px',
		border: 0,
		color: 'white',
		height: 48,
		padding: '0 30px',
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',

		'&:hover': {
      backgroundColor: '#EB505E',
      borderColor: '#EB505E',
      boxShadow: 'none',
		},
		
    '&:focus': {
      background: '#EB505E',
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
      boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)',
    },
	},

	label: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '18px',
		lineHeight: '23px',
		color: '#FFFFFF',
		textTransform: 'none'
	},

	btnSecondary: {
    width: 281,
    background: '#FFFFFF',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '23px',
    color: '#24262A',
    height: 55,
    borderRadius: 48,
    boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)',
    marginTop: 16,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      borderColor: '#FFFFFF',
      boxShadow: 'none',
    },
    '&:focus': {
      background: '#FFFFFF',
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
      boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)',
    },
  },
});

export default function ClassesNesting(props) {
	const classes = useStyles();

	return (
		<Button
			classes={{
				root: classes.root,
				label: classes.label,
			}}

			onClick={props.onClick}

			style={{ height: props.height }}
		>
			{props.text}
		</Button>
	);
}